module.exports = __webpack_public_path__ + "assets/img/算法分批.2b06fb02.jpg";